import type { Point2d } from "@logic/lib/2d"
import { atomFamily, DefaultValue, selectorFamily } from "recoil"

export const findScrollPositionState = atomFamily<Point2d, string>({
  key: `view_scroll`,
  default: { x: 0, y: 0 },
})

export const findPanPositionState = selectorFamily<Point2d, string>({
  key: `view_pan`,
  get:
    (key) =>
    ({ get }): Point2d => {
      const displacement = get(findScrollPositionState(key))

      return invertPoint(displacement)
    },
  set:
    (key) =>
    ({ set }, value) => {
      if (value instanceof DefaultValue) return
      set(findScrollPositionState(key), invertPoint(value))
    },
})

export const invertPoint = (p: Point2d): Point2d => ({
  x: -1 * p.x,
  y: -1 * p.y,
})
